import type { CalendarDay } from '@/types/calendar';

const englishMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export function computeEnglishMonthInfo(
  gridData: (CalendarDay | null)[],
  fallbackYear: number
) {
  const validDays = gridData.filter((day): day is CalendarDay => !!day?.nepali);

  if (validDays.length === 0) {
    return {
      englishYear: fallbackYear - 57,
      englishMonthRange: '',
    };
  }

  const firstDay = validDays.find((day) => day.nepali?.day === 1) || validDays[0];
  const lastDay = validDays.reduce((latest, day) => {
    if (day.nepali && day.nepali.day > (latest?.nepali?.day || 0)) {
      return day;
    }
    return latest;
  }, validDays[0]);

  const parseEnglish = (entry?: CalendarDay) => {
    if (!entry || !entry.english) return { year: 0, month: 0 };
    if (typeof entry.english === 'string') {
      const parts = entry.english.split('-');
      return {
        year: parseInt(parts[0]),
        month: parseInt(parts[1]),
      };
    }
    if (entry.english.date) {
      const parts = entry.english.date.split('-');
      return {
        year: parseInt(parts[0]),
        month: parseInt(parts[1]),
      };
    }
    return {
      year: entry.english.year || 0,
      month: entry.english.month || 0,
    };
  };

  const first = parseEnglish(firstDay);
  const last = parseEnglish(lastDay);
  const fallbackComputedYear = first.year || last.year || fallbackYear - 57;
  let monthRange = '';

  if (first.month > 0 && last.month > 0) {
    const firstName = englishMonths[first.month - 1] || '';
    const lastName = englishMonths[last.month - 1] || '';

    if (first.month === last.month && first.year === last.year) {
      monthRange = `${firstName} ${first.year || fallbackComputedYear}`;
    } else if (first.year === last.year) {
      monthRange = `${firstName}/${lastName} ${first.year || fallbackComputedYear}`;
    } else {
      monthRange = `${firstName} ${first.year || fallbackComputedYear}/${lastName} ${last.year || fallbackComputedYear}`;
    }
  }

  return {
    englishYear: fallbackComputedYear,
    englishMonthRange: monthRange,
  };
}


